import styled from '@emotion/styled'
import { Box, TableCell, TableRow } from '@mui/material'

export const EditChartDataTableContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 5px 5px 5px;
`

export const ChartTableRow = styled(TableRow)`
  height: 60px;
`

export const ChartDateCell = styled(TableCell)`
  padding: 10px;
`

export const ChartTableCell = styled(TableCell)`
  padding: 10px 20px 10px 10px;
`

export const RowActions = styled(Box)`
  display: flex;
  gap: 16px;
  justify-content: center;
`
